<div class="loader">
  <div class="loader__header">
    <div class="loader__title">{{ title }}</div>
    <div class="loader__subtitle">{{ subtitle }}</div>
  </div>

  <div class="progress loader__progress" role="progressbar">
    <div
      class="progress-bar loader__progress__bar"
      [style.animationDuration]="duration + 'ms'"
    ></div>
  </div>

  @if ($step | async; as step) {
    <div class="loader-carousel">
      @for (item of items; track item; let i = $index) {
        <div
          class="loader-carousel__item"
          [class.loader-carousel__item--visible]="step > i"
        >
          <fa-icon
            class="loader-carousel__item__icon"
            [icon]="item.icon"
          ></fa-icon>
          <div class="loader-carousel__item__text">{{ item.text }}</div>
        </div>
      }
    </div>
  }
</div>
